export enum CampaignBlastTypesEnum {
	Email = 'email',
	SMS = 'sms',
}

export enum CampaignBlastStatusesEnum {
	Draft = 'draft',
	Pending = 'pending',
	Scheduled = 'scheduled',
	Sent = 'sent',
	Error = 'error',
}

export enum CampaignAudienceTypeEnum {
	Member = 'member',
	SubscribedMember = 'subscribed_member',
	Location = 'location',
	EventAttendee = 'event_attendee',
	EventWaitlistedUser = 'event_waitlisted_user',
	EventEarlyAccessUser = 'event_early_access_user',
}

export enum CampaignBlastMetricsEnum {
	EmailOpenRate = 'email-open-rate',
	HardBounceRate = 'hard-bounce-rate',
}
